if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        //this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cart = document.querySelector('mini-cart');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) return;
        if (!this.blockSubmitIfSelfhootSizeMissing(evt)) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        //this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = theme.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            //this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      blockSubmitIfRequiredFieldsEmpty(event) {
        if (!(this.form instanceof HTMLFormElement)) {
          throw new Error("Expected a form element.");
        }

        const formId = this.form.getAttribute('id');
        const requiredFields = document.querySelectorAll('[required]');
        let allFilled = true;
        for (const field of requiredFields) {
          const belongsToForm = (field.getAttribute('form') === formId || field.closest('form')?.id === formId);
          if (!belongsToForm) continue;
          
          let isValid = true;
          switch (field.type) {
            case 'checkbox':
            case 'radio':
              const group = document.querySelectorAll(`input[name="${field.name}"][type="${field.type}"]`);
              const isChecked = Array.from(group).some(input => input.checked);
              isValid = isChecked;
              break;
            case 'select-one':
              isValid = field.value !== '';
              break;
            case 'textarea':
            case 'text':
            case 'email':
            case 'number':
            case 'url':
            default:
              isValid = field.value.trim() !== '';
              break;
          }
          if (!isValid) {
            allFilled = false;
            field.classList.add('invalid');
          } else {
            field.classList.remove('invalid');
          }
        }
    
        if (!allFilled) {
          event.preventDefault();
          this.handleErrorMessage(theme.accessibilityStrings.fillInAllLineItemPropertyRequiredFields);
          return false;
        }
        return true;
      }

      blockSubmitIfSelfhootSizeMissing(event) {
        const variantPicker = document.querySelector('variant-selects[data-primary]');
        const sizeFieldset = variantPicker?.querySelector('.product-form__input--with-size-finder');
        if (!sizeFieldset) return true;

        const selectedSize = sizeFieldset.querySelector('input[type="radio"]:checked');
        if (selectedSize) {
          sizeFieldset.classList.remove('selfhoot-size-required-error');
          sizeFieldset.querySelectorAll('input[type="radio"]').forEach((input) => input.removeAttribute('aria-invalid'));
          return true;
        }

        event.preventDefault();
        const message = 'Please select a size first.';
        sizeFieldset.classList.add('selfhoot-size-required-error');
        sizeFieldset.querySelectorAll('input[type="radio"]').forEach((input) => input.setAttribute('aria-invalid', 'true'));
        this.handleErrorMessage(message);
        sizeFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstSizeInput = sizeFieldset.querySelector('input[type="radio"]:not(:disabled)');
        if (firstSizeInput) window.setTimeout(() => firstSizeInput.focus({ preventScroll: true }), 250);
        return false;
      }
      
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = theme.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

(() => {
  const initSelfhootStickyAtc = () => {
    if (!('IntersectionObserver' in window) || !('MutationObserver' in window)) return;
    const stickyBars = document.querySelectorAll('[data-selfhoot-sticky-atc]');
    if (!stickyBars.length) return;

    stickyBars.forEach((bar) => {
      const wrapper = bar.closest('[data-shopify-editor-block]') || bar.parentElement || document;
      const productForm = wrapper.querySelector('product-form') || document.querySelector('product-form');
      const form = productForm?.querySelector('form');
      const mainSubmit = productForm?.querySelector('[type="submit"]');
      const stickySubmit = bar.querySelector('[data-sticky-atc-submit]');
      const priceOutput = bar.querySelector('[data-sticky-atc-price]');
      const optionOutput = bar.querySelector('[data-sticky-atc-options]');
      const priceSource = document.querySelector('[id^="price-"]');
      if (!productForm || !form || !mainSubmit || !stickySubmit) return;

      const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
      let mainButtonVisible = true;

      const syncState = () => {
        const disabled = mainSubmit.disabled || mainSubmit.getAttribute('aria-disabled') === 'true';
        stickySubmit.toggleAttribute('disabled', disabled);
        stickySubmit.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        if (priceOutput && priceSource) {
          const activePrice = priceSource.querySelector('.price-item--sale, .price-item--regular, .price__regular .price-item, .price__sale .price-item');
          if (activePrice?.textContent.trim()) priceOutput.textContent = activePrice.textContent.trim();
        }
        if (optionOutput) {
          const values = Array.from(document.querySelectorAll('variant-selects fieldset'))
            .map((fieldset) => {
              const legend = fieldset.querySelector('.form__label')?.textContent.replace(/:.*/, '').trim();
              if (!legend || !/color|size/i.test(legend)) return null;
              const checked = fieldset.querySelector('input[type="radio"]:checked');
              return checked?.value?.trim() || null;
            })
            .filter(Boolean);
          if (values.length) optionOutput.textContent = values.join(' · ');
        }
      };

      const render = () => {
        const modalOpen = document.body.classList.contains('selfhoot-size-finder-open');
        const shouldShow = isMobile() && !mainButtonVisible && !modalOpen;
        bar.hidden = !shouldShow;
        bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        document.body.classList.toggle('selfhoot-sticky-atc-visible', shouldShow);
        if (shouldShow) syncState();
      };

      stickySubmit.addEventListener('click', () => {
        syncState();
        mainSubmit.click();
      });

      document.addEventListener('change', (event) => {
        if (event.target.matches('variant-selects input[type="radio"], variant-selects select')) {
          const sizeFieldset = event.target.closest('.product-form__input--with-size-finder');
          if (sizeFieldset && event.target.matches('input[type="radio"]')) {
            sizeFieldset.classList.remove('selfhoot-size-required-error');
            sizeFieldset.querySelectorAll('input[type="radio"]').forEach((input) => input.removeAttribute('aria-invalid'));
            const productForm = document.querySelector('product-form');
            productForm?.handleErrorMessage?.();
          }
          window.setTimeout(syncState, 0);
        }
      });

      const observer = new IntersectionObserver((entries) => {
        mainButtonVisible = entries.some((entry) => entry.isIntersecting);
        render();
      }, { threshold: 0.2 });
      observer.observe(mainSubmit);

      const mutationObserver = new MutationObserver(() => {
        syncState();
        render();
      });
      mutationObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      mutationObserver.observe(mainSubmit, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });

      window.addEventListener('resize', render, { passive: true });
      window.addEventListener('scroll', render, { passive: true });
      syncState();
      render();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSelfhootStickyAtc, { once: true });
  } else {
    initSelfhootStickyAtc();
  }
})();



(() => {
  const initSelfhootIntentionalSizeSelection = () => {
    let selectedSize = null;

    const getSizeFieldset = () => document.querySelector('variant-selects[data-primary] .product-form__input--with-size-finder');

    const syncVariantIdFromChosenOptions = () => {
      if (!selectedSize) return;
      const selectedColor = document.querySelector('variant-selects .product-form__input--swatch input[type="radio"]:checked')?.value;
      if (!selectedColor) return;
      const variants = window.ShopifyAnalytics?.meta?.product?.variants || [];
      const match = variants.find((variant) => {
        const publicTitle = String(variant.public_title || '');
        const parts = publicTitle.split('/').map((part) => part.trim());
        return parts[0] === selectedColor && parts[1] === selectedSize;
      });
      if (!match?.id) return;
      document.querySelectorAll('product-form input[name="id"], form.installment input[name="id"]').forEach((input) => {
        input.value = String(match.id);
        input.disabled = false;
      });
    };

    const clearError = (fieldset) => {
      fieldset?.classList.remove('selfhoot-size-required-error');
      fieldset?.querySelectorAll('input[type="radio"]').forEach((input) => input.removeAttribute('aria-invalid'));
      document.querySelector('product-form')?.handleErrorMessage?.();
    };

    const restoreSelectedSize = () => {
      if (!selectedSize) return;
      const fieldset = getSizeFieldset();
      if (!fieldset || fieldset.querySelector('input[type="radio"]:checked')) return;
      const input = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((candidate) => candidate.value === selectedSize && !candidate.disabled);
      if (!input) return;
      input.checked = true;
      syncVariantIdFromChosenOptions();
      clearError(fieldset);
    };

    document.addEventListener('change', (event) => {
      const sizeInput = event.target.closest?.('.product-form__input--with-size-finder input[type="radio"]');
      if (sizeInput) {
        selectedSize = sizeInput.value;
        syncVariantIdFromChosenOptions();
        clearError(sizeInput.closest('.product-form__input--with-size-finder'));
        window.setTimeout(restoreSelectedSize, 250);
        window.setTimeout(restoreSelectedSize, 900);
        return;
      }

      if (event.target.matches?.('variant-selects .product-form__input--swatch input[type="radio"]')) {
        window.setTimeout(syncVariantIdFromChosenOptions, 0);
      }
    });

    const observer = new MutationObserver(() => restoreSelectedSize());
    observer.observe(document.documentElement, { childList: true, subtree: true });
    restoreSelectedSize();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSelfhootIntentionalSizeSelection, { once: true });
  } else {
    initSelfhootIntentionalSizeSelection();
  }
})();

(() => {
  const removeSelfhootBenefitBadges = () => {
    document.querySelectorAll('.product__info-container .futureblink-badge-banner, product-form .futureblink-badge-banner').forEach((badge) => {
      badge.remove();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeSelfhootBenefitBadges, { once: true });
  } else {
    removeSelfhootBenefitBadges();
  }

  const observer = new MutationObserver(removeSelfhootBenefitBadges);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
